import "../stylesheets/CaptchaScreen.css";

import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { FaLock } from "react-icons/fa";
import AuthorizationManager from "../manager/AuthorizationManager";
import NetworkManager from "../manager/NetworkManager";
import ScreenManager from "../manager/ScreenManager";

const authorizationManager = AuthorizationManager.instance;
const networkManager = NetworkManager.instance;
const screenManager = ScreenManager.instance;

export default class CaptchaScreen extends React.PureComponent {

    captchaRef = React.createRef();

    async componentDidMount() {
        try {
            if (AuthorizationManager.sessionToken) {
                console.log(`There is currently the session token "${AuthorizationManager.sessionToken}" set. Checking if it is valid...`);
                await networkManager.fetch("/checkLogin");
                console.log("Token was valid! Continuing to next screen :)");
                screenManager.changeScreen("AddEntry");
            }
        } catch(e) {
            console.warn("The session token was invalid. Need to solve the captcha!");
        }
    }

    render() {

        return (

            <div className="flexContainer secondaryColorBackground centeredHorizontal centeredVertical">
                <h3 className="CaptchaScreenHeader" >Bitte löse dieses Captcha um fortzufahren.</h3>

                <FaLock
                    size="15em"
                    className="CaptchaScreenPadding"
                />

                <ReCAPTCHA
                    ref={this.captchaRef}
                    sitekey="6Lf_SrgUAAAAAEmhEQMUUesn1oQEt9V8YluoX0bu"
                    onChange={this.onChange.bind(this)}
                    hl="de"
                />

                {this.props.children}
            </div>

        );

    }

    /**
     * @param {string} token 
     */
    async onChange( token ) {


        if (token == null) {
            console.log("Captcha is expired!");
            if (this.captchaRef.current) this.captchaRef.current.reset();
            return;
        }

        // set token
        console.log(`Received captcha token: "${token}"`);
        authorizationManager.captchaKey = token;

        try {
            await networkManager.fetch("/checkLogin");
            screenManager.changeScreen("AddEntry");
        } catch(e) {
            if (e === NetworkManager.UNAUTHORIZED_ERROR) {
                screenManager.showError("Das Captcha war ungültig! Bitte versuchen Sie es erneut.");
                if (this.captchaRef.current) this.captchaRef.current.reset();
            } else {
                console.error("Could not check login:", e);
                screenManager.showError("Das Captcha konnte aus unbekannten Gründen nicht geprüft werden!");
            }
        }

    }
    
}